<template>
    <ai-popup
        v-model:visible="showPopup"
        :show-close-button="true"
        :animation="{ value: false }"
        :firstButtonText="'Отправить запрос'"
        :bottomButtonsEnabled="true"
        :firstButtonEnabled="true"
        :secondButtonEnabled="false"
        @close-popup="onClosePopup"
        @submit-click="sendHandler"
        :firstButtonDisabled="sendButtonDisabled"
        title="Написать в техническую поддержку"
        height="auto"
        width="42%"
    >
        <div class="flex flex-col overflow-hidden">
            <dx-form :form-data="allFormData" ref="formRef" class="custom-users-card">
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox"
                    :label="{ visible: false }"
                    data-field="theme"
                    editor-type="dxTagBox"
                    :editor-options="tagBoxOptions"
                />
                <dx-simple-item
                    cssClass="custom-padding-textbox-and-selectbox2"
                    :label="{ visible: false }"
                    data-field="message"
                    :editor-options="textBoxOptions"
                />
            </dx-form>
            <dx-file-uploader
                class="custom-file-uploader"
                :upload-url="url"
                @value-changed="onUploadValueChanged"
                @before-send="onBeforeSend"
                :active-state-enabled="true"
                :allowCanceling="true"
                :abort-upload="true"
                uploadMode="useButtons"
                select-button-text="Выберите файл"
                :multiple="true"
            >
            </dx-file-uploader>
            <p class="text">Ограничение: не более 10 файлов, каждый не более 10 Мб.</p>
        </div>
    </ai-popup>
</template>

<script>
export default {
    name: 'support-popup',
};
</script>

<script setup>
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxForm, DxSimpleItem } from 'devextreme-vue/form';
import { ref, computed, reactive, onMounted } from 'vue';
import { sendSupportRequest } from '@/service/notification-service';
import { dxUiNotify } from '@/utils/dx-helper';
import { getURL } from '@/service/http';
import { uploadFileToStorage } from '@/service/upload-file-service';
import { getOfficialUserData, getUser } from '@/service/admin-service';
import AiPopup from '@/components/ai-popup/ai-popup.vue';

import { getDataSource } from '@/service/meta-service';

const url = computed(() => {
    return getURL('upload');
});
const formRef = ref();
const user = ref();
const allFormData = reactive({
    theme: '',
    message: '',
});
const uploadValueRef = ref([]);
const showPopup = ref(false);
const isDropDownOpen = ref(false);
const isSelectEmpty = ref(false);
const emit = defineEmits('popupClosed');

const state = reactive({
    themeOptions: [],
});

onMounted(async () => {
    showPopup.value = true;
    const officialUserData = await getUser();
    user.value = await getOfficialUserData(officialUserData.official_id);
    const supportDataGrid = await getDataSource('admin./admin/ms-support-select/get');
    state.themeOptions = supportDataGrid.data;
});

const dropdownRotation = computed(() => {
    return isDropDownOpen.value ? 'rotate(180deg)' : 'rotate(0)';
});

const sendButtonDisabled = computed(() => {
    return allFormData.theme.length === 0 || allFormData.message.length === 0;
});

const onClosePopup = () => {
    showPopup.value = false;
    emit('popupClosed');
};

const onBeforeSend = e => {
    // Установить нужные заголовки
    const request = e.request;
    request.setRequestHeader('X-ASUSE-Type', encodeURI('Файл-пользователя'));
    request.setRequestHeader('X-ASUSE-Schema', encodeURI('ТехПоддержка'));
    request.setRequestHeader('X-ASUSE-Login', 'developer');

    // const info = [];
    // info.push({
    //     dt: new Date(e.file.lastModified).toISOString(),
    // });

    // const formData = new FormData();
    // formData.append('info', JSON.stringify(info));
    // formData.append('file', e.file); // Assuming e.file is the File object

    // Set the request body to the form data
    // request.data = formData;

    // Установить тело запроса
    // request.data = {... request.data, info: JSON.stringify(info), fields: info};
    // e.uploadInfo = JSON.stringify({info: [{dt: e.file.lastModifiedDate}]})
    // e.component.option("fields", JSON.stringify([{a: 100}]))
    // console.log('onBeforeSend', e);
};

// const handleFileSelect = e => {
//     const files = e.target.files;
//     // Validate the files (e.g., check the number and size)
//     if (files.length <= 10 && Array.from(files).every(file => file.size <= 10 * 1024 * 1024)) {
//         // Process the selected files
//         // You can store the files in a variable or send them to your server
//         console.log('Selected files:', files);
//         formFiles = [...files];
//     } else {
//         // Handle invalid file selection
//         console.log('Invalid file selection');
//         formFiles = [];
//     }
// };

const onUploadValueChanged = event => {
    uploadValueRef.value.push(event.value);
};

const doUpload = async () => {
    if (uploadValueRef.value.length) {
        for (const file of uploadValueRef.value) {
            try {
                const uploadedFile = await uploadFileToStorage(file, {
                    Type: 'Счет-фактура',
                    Schema: 'Финансы',
                });
                console.log('uploadedFile', uploadedFile);
            } catch (error) {
                console.error('Ошибка загрузки файла:', error);
                dxUiNotify({
                    message: `Ошибка загрузки файла: ${error.message}`,
                    type: 'error',
                });
                return;
            }
        }
    }
};

const prepareRequestBody = () => {
    return {
        users: [
            {
                name: user.value.fio,
                to: { email: 'asuse-support@infoenergo.ru' },
            },
        ],
        msg: {
            category: 'info',
            subject: allFormData.theme[0],
            text: allFormData.message,
            from: {
                email: user.value.e_mail,
            },
        },
        files: [
            {
                name: 'text-file.txt',
                path: 'https://drive.google.com/uc?id=1zO8ekHWx9U7mrbx_0Hoxxu6od7uxJqWw&export=download',
            },
        ],
    };
};

const sendHandler = async () => {
    await doUpload();

    const requestBody = prepareRequestBody();
    const res = await sendSupportRequest(requestBody);
    try {
        res.accepted.length
            ? dxUiNotify({
                  message: 'Запрос успешно отправлен',
                  type: 'success',
              })
            : dxUiNotify({
                  message: 'Ошибка при отправке запроса',
                  type: 'error',
              });
    } catch (error) {
        dxUiNotify({
            message: `Произошла ошибка: ${error.message}`,
            type: 'error',
        });
    }
};

const textBoxOptions = {
    placeholder: 'Введите текст запроса',
    onValueChanged: e => {
        console.log(e);
    },
};

const tagBoxOptions = computed(() => ({
    dataSource: state.themeOptions,
    displayExpr: 'topic',
    valueExpr: 'topic',
    wrapItemText: true,
    placeholder: 'Выберите тему сообщения',
    showClearButton: false,
    acceptCustomValue: false,
    onOpened: () => {
        isDropDownOpen.value = true;
    },
    onClosed: () => {
        isDropDownOpen.value = false;
    },
    onValueChanged: function (e) {
        const value = e.value;
        isSelectEmpty.value = !e.value || e.value.length === 0;
        allFormData.theme = e.value;

        if (value && value.length > 1) {
            e.component.option('value', [value[value.length - 1]]);
        }
    },
}));
</script>

<style lang="scss">
.custom-users-card {
    .custom-padding-textbox-and-selectbox {
        .dx-texteditor.dx-editor-filled {
            background-color: #e3f1ff !important;
            border-radius: 6.27px !important;
        }

        .dx-texteditor.dx-editor-filled .dx-placeholder::before {
            padding: 9px 0 9px 12px;
        }

        .dx-texteditor.dx-tagbox .dx-tag-container::after {
            content: '';
            display: block;
            width: 14px;
            height: 8px;
            right: 1%;
            top: 42%;
            position: absolute;
            background-image: url('../../assets/forward.svg');
            background-size: contain;
            background-repeat: no-repeat;
            transition: transform 0.3s ease;
            transform: v-bind(dropdownRotation);
        }

        .dx-tag-content {
            background: none;
            color: #031425;
            line-height: 100%;
            padding-inline-start: 0;
        }

        .dx-tag-remove-button::before {
            display: none;
        }

        .dx-tag-remove-button {
            margin-right: 3px;
        }

        .dx-placeholder {
            font-size: 12.53px;
            color: #031425;
            padding-right: 0;
        }

        .dx-placeholder::after {
            content: '*';
            color: red;
            padding-top: 7px;
            margin-left: 3px;
        }

        .dx-tagbox.dx-tagbox-default-template.dx-tagbox-only-select .dx-texteditor-input {
            text-shadow: none;
        }
    }

    .custom-padding-textbox-and-selectbox2 {
        .dx-texteditor.dx-editor-filled {
            background-color: #e3f1ff !important;
            border-radius: 6.27px !important;
        }

        .dx-texteditor.dx-editor-filled .dx-placeholder::before {
            padding: 9px 0 9px 12px;
        }

        .dx-texteditor-input-container {
            margin-bottom: 25px;
        }

        .dx-placeholder {
            font-size: 12.53px;
            color: #031425;
        }

        .dx-placeholder::after {
            content: '*';
            color: red;
            padding-top: 7px;
            margin-left: 3px;
        }
    }
}

.custom-file-uploader {
    .dx-button-mode-contained {
        box-shadow: none;
        height: auto;
    }
    .dx-button-content {
        border: 1px solid #939393;
        border-radius: 6.22px;
        box-shadow: none;
        padding: 12px 52px;
        height: auto;
    }

    .dx-button-content:focus-visible {
        background-color: white;
        border: none;
    }

    .dx-button-text {
        font-size: 12px;
        font-weight: 600;
        color: #031425;
        text-transform: none;
        font-family: GolosText;
        line-height: 100%;
        letter-spacing: 0%;
    }

    .dx-fileuploader-input-label {
        padding: 6.75px 22px;
        color: #031425;
        display: flex;
        align-items: center;
    }

    .dx-fileuploader-wrapper {
        padding: 0;
    }

    .dx-fileuploader-content > .dx-fileuploader-upload-button {
        display: none;
    }

    .dx-icon-upload:before {
        content: '';
        display: block;
        width: 25px;
        height: 25px;
        background-image: url('../../assets/upload.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-color: white;
        border-radius: 0;
    }

    .dx-icon-upload:hover::before {
        content: '';
        display: block;
        width: 25px;
        height: 25px;
        background-image: url('../../assets/upload-hover.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-color: white;
        border-radius: 0;
    }

    .dx-icon-close:hover::before {
        content: '';
        display: block;
        width: 25px;
        height: 25px;
        background-image: url('../../assets/cancel-hover.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-color: white;
        border-radius: 0;
    }

    .dx-fileuploader-upload-button.dx-state-hover {
        background-color: white;
    }

    .dx-fileuploader-cancel-button.dx-state-hover {
        background-color: white;
    }

    .dx-icon-upload:focus-visible {
        background-color: white;
        box-shadow: none;
    }

    .dx-icon-close:before {
        content: '';
        display: block;
        width: 25px;
        height: 25px;
        background-image: url('../../assets/cancel.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-color: white;
        border-radius: 0;
    }

    .dx-icon-close:focus-visible {
        background-color: white;
    }

    .dx-fileuploader-files-container .dx-fileuploader-button .dx-button-content {
        border: none;
    }
    .dx-button .dx-icon {
        height: auto;
        width: auto;
    }

    .dx-fileuploader-files-container .dx-fileuploader-file-container {
        border: 1.24px solid #0314251a;
        box-shadow: none;
        border-radius: 6.22px;
    }

    .dx-fileuploader-files-container .dx-fileuploader-file-container .dx-button {
        margin-right: 5px;
    }
}

.text {
    color: #939393;
}
</style>
